import Service from "@ember/service"
import ENV from "../config/environment"

export default class Stripe extends Service {
  handler: Promise<any>
  private handlerResolve!: (handler: any) => void

  constructor() {
    super(...arguments)

    this.handler = new Promise((resolve) => {
      this.handlerResolve = resolve
    })

    // @ts-expect-error No type for StripeCheckout
    if (typeof StripeCheckout !== "undefined") {
      this.initHandler()
    } else {
      const stripeScript = document.getElementById("stripe-js") as HTMLScriptElement
      stripeScript.onload = () => {
        // @ts-expect-error No type for StripeCheckout
        if (typeof StripeCheckout !== "undefined") {
          this.initHandler()
        } else {
          console.error("StripeCheckout is not defined")
        }
      }
    }
  }

  private initHandler() {
    // @ts-expect-error No type for StripeCheckout
    const handler = StripeCheckout.configure({
      key: ENV.STRIPE_PK,
      name: "Common Curriculum",
      allowRememberMe: false,
      image:
        "https://s3.amazonaws.com/stripe-uploads/acct_1slDKG2dCO1jWXaYWC9tmerchant-icon-1439149859517-logo-300-square.png",
    })
    this.handlerResolve(handler)
  }
}
